import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { fetchTenantUsers, TenantUserInfo } from '../../redux/actions/dashboard'
import TenantUsersTable from './TenantUsersTable'

/*
 * Loginy vlastneho tenanta pre bezneho admina (nie superadmina):
 * pridat / premenovat / zmazat login a nastavit heslo ostatnym loginom (vlastne heslo cez "Change password").
 */

const useStyles = makeStyles((theme) => ({
    section: {
        marginTop: theme.spacing(2),
    },
    headerWrapper: {
        padding: theme.spacing(1),
    },
    paper: {
        width: '100%',
        margin: theme.spacing(1),
        padding: theme.spacing(1, 2, 2),
    },
    centered: {
        padding: theme.spacing(4),
        textAlign: 'center',
    },
}))

interface Props {
    onSuccess: (msg: string) => void
    onError: (msg: string) => void
}

export default function OwnTenantUsers({ onSuccess, onError }: Props) {
    const classes = useStyles()
    const { t } = useTranslation()
    const tenantId: string | undefined = useSelector((state: any) => state.login.value.user.tenantId)
    const [users, setUsers] = useState<TenantUserInfo[]>()
    const [error, setError] = useState<string>()

    const loadUsers = () => {
        fetchTenantUsers()
            .then((result) => {
                setUsers(result ?? [])
                setError(undefined)
            })
            .catch((e: any) => setError(e?.message || 'unknown error'))
    }

    useEffect(() => {
        loadUsers()
    }, [])

    return (
        <Grid className={classes.section}>
            <Grid className={classes.headerWrapper}>
                <Typography align="left" variant="h6">
                    {t('dashboard.tenantUsersTitle')}
                </Typography>
            </Grid>
            <Paper className={classes.paper}>
                {!users && !error ? (
                    <div className={classes.centered}>
                        <CircularProgress size={32} />
                    </div>
                ) : (
                    <TenantUsersTable
                        users={users ?? []}
                        tenantId={tenantId}
                        isSuperAdmin={false}
                        loadError={error}
                        showTitle={false}
                        onChanged={loadUsers}
                        onSuccess={onSuccess}
                        onError={onError}
                    />
                )}
            </Paper>
        </Grid>
    )
}
